import { DefaultState } from 'store/reducers/types';

export const READ_SLOTS_DATA_REQUEST = "READ_SLOTS_DATA_REQUEST";
export const READ_SLOTS_DATA_SUCCESS = "READ_SLOTS_DATA_SUCCESS";
export const READ_SLOTS_DATA_FAILURE = "READ_SLOTS_DATA_FAILURE";

export interface SlotsData {
  filled: number;
  unfilled: number;
};

export type SlotsState = DefaultState & {
  contents?: SlotsData;
};

interface ReadSlotsDataRequest {
  type: typeof READ_SLOTS_DATA_REQUEST;
};

interface ReadSlotsDataSuccess {
  type: typeof READ_SLOTS_DATA_SUCCESS;
  contents: SlotsData;
};

interface ReadSlotsDataFailure {
  type: typeof READ_SLOTS_DATA_FAILURE;
};

export type SlotsActionTypes = ReadSlotsDataRequest | ReadSlotsDataSuccess | ReadSlotsDataFailure;